import { SelectedAddons } from '../../state/types';

export const aggregateParticipantAddons = (
  participantAddons: SelectedAddons[] | undefined,
): SelectedAddons =>
  participantAddons?.reduce<SelectedAddons>((aggregate, selection) => {
    Object.entries(selection ?? {}).forEach(([groupId, groupAddons]) => {
      Object.entries(groupAddons).forEach(([addonId, addon]) => {
        if (!aggregate[groupId]) {
          aggregate[groupId] = {};
        }
        const existing = aggregate[groupId][addonId];
        aggregate[groupId][addonId] = existing
          ? { ...existing, quantity: existing.quantity + addon.quantity }
          : { ...addon };
      });
    });
    return aggregate;
  }, {}) ?? {};
